// Bryntum Gantt locale - Portuguese Brazil
const locale = {

    localeName : 'PtBr',
    localeDesc : 'Português do Brasil',
    localeCode : 'pt-BR',

    Object : {
        Save : 'Salvar',
        newEvent : 'Novo evento',
        Yes    : 'Sim',
        No     : 'Não',
        Cancel : 'Cancelar',
        Ok     : 'OK',
        Week   : 'Semana',
        None   : 'Nenhum'
    },

    IgnoreResourceCalendarColumn : {
        'Ignore resource calendar' : 'Ignorar calendário de recursos'
    },

    InactiveColumn : {
        Inactive : 'Inativo'
    },

    AddNewColumn : {
        'New Column' : 'Nova coluna'
    },

    BaselineStartDateColumn : {
        baselineStart : 'Início do Plano Base'
    },

    BaselineEndDateColumn : {
        baselineEnd : 'Conclusão do Plano Base'
    },

    BaselineDurationColumn : {
        baselineDuration : 'Duração do Plano Base'
    },

    BaselineStartVarianceColumn : {
        startVariance : 'Desvio de Início'
    },

    BaselineEndVarianceColumn : {
        endVariance : 'Desvio de Conclusão'
    },

    BaselineDurationVarianceColumn : {
        durationVariance : 'Variância de duração'
    },

    CalendarColumn : {
        Calendar : 'Calendário'
    },

    EarlyStartDateColumn : {
        'Early Start' : 'Fase inicial'
    },

    EarlyEndDateColumn : {
        'Early End' : 'Fim prematuro'
    },

    LateStartDateColumn : {
        'Late Start' : 'Início atrasado'
    },

    LateEndDateColumn : {
        'Late End' : 'Fim atrasado'
    },

    TotalSlackColumn : {
        'Total Slack' : 'Folga total'
    },

    ConstraintDateColumn : {
        'Constraint Date' : 'Data de restrição'
    },

    ConstraintTypeColumn : {
        'Constraint Type' : 'Tipo de restrição'
    },

    DeadlineDateColumn : {
        Deadline : 'Prazo'
    },

    DependencyColumn : {
        'Invalid dependency' : 'Dependência inválida'
    },

    DurationColumn : {
        Duration : 'Duração'
    },

    EffortColumn : {
        Effort : 'Esforço'
    },

    EndDateColumn : {
        Finish : 'Fim'
    },

    ManuallyScheduledColumn : {
        'Manually scheduled' : 'Agendado manualmente'
    },

    MilestoneColumn : {
        Milestone : 'Marco'
    },

    NameColumn : {
        Name : 'Nome'
    },

    NoteColumn : {
        Note : 'Nota'
    },

    PercentDoneColumn : {
        '% Done' : '% concluído'
    },

    PlannedPercentDoneColumn : {
        plannedPercentDone : '% Planejado Feito'
    },

    PredecessorColumn : {
        Predecessors : 'Anteriores'
    },

    ResourceAssignmentColumn : {
        'Assigned Resources' : 'Recursos atribuídos',
        'more resources'     : 'mais recursos'
    },

    RollupColumn : {
        Rollup : 'Sumarização'
    },

    SchedulingModeColumn : {
        'Scheduling Mode' : 'Modo de agendamento'
    },

    SchedulingDirectionColumn : {
        schedulingDirection : 'Direção de agendamento',
        inheritedFrom       : 'Herdado de',
        enforcedBy          : 'Imposto por'
    },

    SequenceColumn : {
        Sequence : 'Sequência'
    },

    ShowInTimelineColumn : {
        'Show in timeline' : 'Mostrar na linha do tempo'
    },

    StartDateColumn : {
        Start : 'Início'
    },

    SuccessorColumn : {
        Successors : 'Sucessores'
    },

    TaskCopyPaste : {
        copyTask  : 'Copiar',
        cutTask   : 'Cortar',
        pasteTask : 'Colar'
    },

    WBSColumn : {
        WBS      : 'WBS',
        renumber : 'Renumerar'
    },

    DependencyField : {
        invalidDependencyFormat : 'Formato de dependência inválido'
    },

    ProjectLines : {
        'Project Start' : 'Início do projeto',
        'Project End'   : 'Fim do projeto',
        statusDate      : 'Data de status'
    },

    TaskTooltip : {
        Start    : 'Início',
        End      : 'Fim',
        Duration : 'Duração',
        Complete : 'Concluído'
    },

    AssignmentGrid : {
        Name     : 'Nome do recurso',
        Units    : 'Unidades',
        unitsTpl : ({ value }) => value ? value + '%' : ''
    },

    Gantt : {
        Edit                   : 'Editar',
        Indent                 : 'Avanço',
        Outdent                : 'Diminuir avanço',
        'Convert to milestone' : 'Converter para marco',
        Add                    : 'Adicionar...',
        'New task'             : 'Nova tarefa',
        'New milestone'        : 'Novo marco',
        'Task above'           : 'Tarefa acima',
        'Task below'           : 'Tarefa abaixo',
        'Delete task'          : 'Eliminar',
        Milestone              : 'Marco',
        'Sub-task'             : 'Subtarefa',
        Successor              : 'Sucessor',
        Predecessor            : 'Predecessor',
        changeRejected         : 'O motor de agendamento rejeitou as alterações',
        linkTasks              : 'Adicionar dependências',
        unlinkTasks            : 'Remover dependências',
        color                  : 'Cor'
    },

    EventSegments : {
        splitTask : 'Dividir tarefa',
        splitEvent    : 'Dividir evento',
        renameSegment : 'Renomear'
    },

    Indicators : {
        earlyDates   : 'Início/fim antecipado',
        lateDates    : 'Início/fim atrasado',
        Start        : 'Início',
        End          : 'Fim',
        deadlineDate : 'Prazo'
    },

    Versions : {
        indented     : 'Indentado',
        outdented    : 'Desindentado',
        cut          : 'Cortado',
        pasted       : 'Colado',
        deletedTasks : 'Tarefas excluídas',
        entityNames : {
            TaskModel       : 'tarefa',
            AssignmentModel : 'atribuição',
            DependencyModel : 'hiperligação',
            ProjectModel    : 'projeto',
            ResourceModel   : 'recurso',
            other           : 'objeto'
        },
        entityNamesPlural : {
            TaskModel       : 'tarefas',
            AssignmentModel : 'atribuições',
            DependencyModel : 'hiperligações',
            ProjectModel    : 'projetos',
            ResourceModel   : 'recursos',
            other           : 'objetos'
        },
        transactionDescriptions : {
            update : 'Alterada(s) {n} {entities}',
            add    : 'Adicionada(s) {n} {entities}',
            remove : 'Removida(s) {n} {entities}',
            move   : 'Movida(s) {n} {entities}',
            mixed  : 'Alterada(s) {n} {entities}'
        },
        addEntity         : 'Adicionado {type} **{name}**',
        removeEntity      : 'Removido {type} **{name}**',
        updateEntity      : 'Alterado {type} **{name}**',
        moveEntity        : 'Movido {type} **{name}** de {from} para {to}',
        addDependency     : 'Adicionada hiperligação de **{from}** para **{to}**',
        removeDependency  : 'Removida hiperligação de **{from}** para **{to}**',
        updateDependency  : 'Editada hiperligação de **{from}** para **{to}**',
        addAssignment     : 'Atribuído **{resource}** para **{event}**',
        removeAssignment  : 'Removida atribuição de **{resource}** de **{event}**',
        updateAssignment  : 'Editada atribuição de **{resource}** para **{event}**',
        noChanges         : 'Sem alterações',
        nullValue         : 'nenhum',
        versionDateFormat : 'M/D/YYYY h:mm a',
        undid             : 'Alterações anuladas',
        redid             : 'Alterações refeitas',
        editedTask        : 'Propriedades da tarefa editadas',
        deletedTask       : 'Uma tarefa removida',
        movedTask         : 'Uma tarefa movida',
        movedTasks        : 'Tarefas movidas'
    },

    ConstraintTypePicker : {
        none                : 'Nenhum',
        assoonaspossible    : 'O mais cedo possível',
        aslateaspossible    : 'O mais tarde possível',
        muststarton         : 'Tem de começar em',
        mustfinishon        : 'Tem de terminar em',
        startnoearlierthan  : 'Iniciar não antes de',
        startnolaterthan    : 'Iniciar não depois de',
        finishnoearlierthan : 'Terminar não antes de',
        finishnolaterthan   : 'Terminar não depois de'
    },

    SchedulingDirectionPicker : {
        Forward       : 'Para a frente',
        Backward      : 'Para trás',
        inheritedFrom : 'Herdado de',
        enforcedBy    : 'Imposto por'
    },

    CalendarField : {
        'Default calendar' : 'Calendário predefinido',
        editCalendar       : 'Editar calendário'
    },

    TaskEditorBase : {
        Information   : 'Informação',
        Save          : 'Guardar',
        Cancel        : 'Cancelar',
        Delete        : 'Eliminar',
        calculateMask : 'A calcular...',
        saveError     : 'Não é possível salvar, corrija os erros primeiro',
        repeatingInfo : 'Visualizar um evento repetido',
        editRepeating : 'Editar'
    },

    TaskEdit : {
        editEvent              : 'Editar evento',
        ConfirmDeletionTitle   : 'Confirmar remoção',
        ConfirmDeletionMessage : 'Tem a certeza de que quer remover o evento?'
    },

    GanttTaskEditor : {
        editorWidth : '44em'
    },

    SchedulerTaskEditor : {
        editorWidth : '32em'
    },

    SchedulerGeneralTab : {
        labelWidth   : '6em',
        General      : 'Geral',
        Name         : 'Nome',
        Resources    : 'Recursos',
        '% complete' : '% concluído',
        Duration     : 'Duração',
        Start        : 'Início',
        Finish       : 'Fim',
        Effort       : 'Esforço',
        Preamble     : 'Preâmbulo',
        Postamble    : 'Conclusão'
    },

    GeneralTab : {
        labelWidth   : '6.5em',
        General      : 'Geral',
        Name         : 'Nome',
        '% complete' : '% concluído',
        Duration     : 'Duração',
        Start        : 'Início',
        Finish       : 'Fim',
        Effort       : 'Esforço',
        Dates        : 'Datas'
    },

    SchedulerAdvancedTab : {
        labelWidth                 : '13em',
        Advanced                   : 'Avançado',
        Calendar                   : 'Calendário',
        'Scheduling mode'          : 'Modo de agendamento',
        'Effort driven'            : 'Esforço impulsionado',
        'Manually scheduled'       : 'Agendado manualmente',
        'Constraint type'          : 'Tipo de restrição',
        'Constraint date'          : 'Data de restrição',
        Inactive                   : 'Inativo',
        'Ignore resource calendar' : 'Ignorar calendário de recursos'
    },

    CalendarEditorDatePicker : {
        addException : 'Adicione exceção',
        addWeek      : 'Adicionar semana'
    },

    CalendarEditorExceptionTab : {
        addException    : 'Adicione exceção',
        removeException : 'Remover exceção',
        noRows          : 'Nenhuma exceção adicionada'
    },

    CalendarEditorWeekTab : {
        addWeek    : 'Adicionar semana',
        removeWeek : 'Remover semana'
    },

    CalendarEditor : {
        daysAreWorkingByDefault    : 'Os dias estão funcionando por padrão',
        workingTimeCalendar        : 'Calendário de horário de trabalho',
        exceptions                 : 'Exceções',
        general                    : 'Em geral',
        name                       : 'Nome',
        parent                     : 'Pai',
        save                       : 'Salvar',
        weeks                      : 'Semanas',
        error                      : 'Erro',
        inputErrors                : 'Existem erros de entrada. Corrija-os antes de salvar suas alterações.',
        delete                     : 'Excluir',
        addCalendar                : 'Adicionar um calendário',
        confirmation               : 'Confirmação',
        removeCalendarWithChildren : 'O calendário tem calendários secundários. Clique em "Sim" para remover o calendário com seus filhos.',
        removeCalendarAndLinks     : 'O calendário é usado por alguns registros. Clique em "Sim" para desvinculá-los e remover o calendário.'
    },

    CalendarEditorDateInfo : {
        isWorking    : ' está funcionando',
        isNotWorking : ' não está funcionando',
        basedOn      : ' baseado em:',
        byDefault    : 'por padrão',
        rangeTpl     : (start, end) => `${start} - ${end}`
    },

    CalendarEditorLegend : {
        workingDay    : 'Dia de trabalho',
        nonWorkingDay : 'Dia não útil'
    },

    AvailabilityRangeError : {
        errorOverlap       : 'Existem intervalos sobrepostos',
        errorMissingDate   : 'Os horários de início e término são obrigatórios',
        errorStartAfterEnd : 'O horário de início não pode ser posterior ao horário de término'
    },

    CalendarEditorExceptionPanel : {
        name                                 : 'Nome',
        from                                 : 'De',
        to                                   : 'Para',
        is                                   : 'É',
        nonWorking                           : 'Não trabalhando',
        working                              : 'Trabalhando',
        hours                                : 'Horas',
        repeat                               : 'Repita',
        repeatEnd                            : 'Repetir fim',
        errorMissingDate                     : 'O período de exceção é obrigatório',
        errorStartAfterEnd                   : 'A data "De" não pode ser posterior à data "Até"',
        errorStartAndEndRepeatNumberMismatch : 'A exceção deve começar e terminar o mesmo número de vezes'
    },

    CalendarEditorWeekPanel : {
        name        : 'Nome',
        from        : 'De',
        to          : 'Para',
        days        : 'Dias',
        copyDay     : 'Dia de cópia',
        pasteDay    : 'Colar dia',
        stopCopying : 'Pare de copiar'
    },

    CalendarEditorAvailabilityRangeContainer : {
        addRange    : 'Adicionar intervalo',
        removeRange : 'Remover intervalo'
    },

    CalendarEditorWeekGrid : {
        errorStartAfterEnd           : 'A data "De" não pode ser posterior à data "Até"',
        errorNoDefaultWeek           : 'A configuração da semana é obrigatória',
        errorMultipleDefaultWeeks    : 'Mais de uma semana padrão é especificada',
        errorNoWeekAvailability      : 'A semana deve fornecer algum tempo de trabalho',
        errorInvalidWeekAvailability : 'Semana tem erros de configuração de horário de trabalho',
        noRows                       : 'Nenhuma semana adicionada'
    },

    AdvancedTab : {
        labelWidth                 : '11.5em',
        Advanced                   : 'Avançado',
        Calendar                   : 'Calendário',
        'Scheduling mode'          : 'Modo de agendamento',
        'Effort driven'            : 'Esforço impulsionado',
        'Manually scheduled'       : 'Agendado manualmente',
        'Constraint type'          : 'Tipo de restrição',
        'Constraint date'          : 'Data de restrição',
        Constraint                 : 'Restrição',
        Rollup                     : 'Sumarização',
        Inactive                   : 'Inativo',
        'Ignore resource calendar' : 'Ignorar calendário de recursos',
        'Scheduling direction'     : 'Direção de agendamento',
        projectBorder              : 'Fronteira do projeto',
        ignore                     : 'Ignorar',
        honor                      : 'Honra',
        askUser                    : 'Pergunte ao usuário'
    },

    DependencyTab : {
        Predecessors      : 'Anteriores',
        Successors        : 'Sucessores',
        ID                : 'ID',
        Name              : 'Nome',
        Type              : 'Tipo',
        Lag               : 'Atraso',
        cyclicDependency  : 'Dependência cíclica',
        invalidDependency : 'Dependência inválida'
    },

    NotesTab : {
        Notes : 'Notas'
    },

    ResourceCalendarColumn : {
        calendar : 'Calendário'
    },

    ResourcesTab : {
        unitsTpl  : ({ value }) => `${value}%`,
        Resources : 'Recursos',
        Resource  : 'Recurso',
        Units     : 'Unidades'
    },

    RecurrenceTab : {
        title : 'Repetir'
    },

    SchedulingModePicker : {
        Normal           : 'Normal',
        'Fixed Duration' : 'Duração fixa',
        'Fixed Units'    : 'Unidades fixas',
        'Fixed Effort'   : 'Esforço fixo'
    },

    ResourceHistogram : {
        barTipInRange         : '<b>{resource}</b> {startDate} - {endDate}<br><span class="{cls}">{allocated} de {available}</span> atribuídos',
        barTipOnDate          : '<b>{resource}</b> em {startDate}<br><span class="{cls}">{allocated} de {available}</span> atribuídos',
        groupBarTipAssignment : '<b>{resource}</b> - <span class="{cls}">{allocated} de {available}</span>',
        groupBarTipInRange    : '{startDate} - {endDate}<br><span class="{cls}">{allocated} de {available}</span> allocated:<br>{assignments}',
        groupBarTipOnDate     : 'Em {startDate}<br><span class="{cls}">{allocated} de {available}</span> atribuídos:<br>{assignments}',
        plusMore              : '+{value} mais'
    },

    ResourceUtilization : {
        barTipInRange         : '<b>{event}</b> {startDate} - {endDate}<br><span class="{cls}">{allocated}</span> atribuídos',
        barTipOnDate          : '<b>{event}</b> em {startDate}<br><span class="{cls}">{allocated}</span> atribuídos',
        groupBarTipAssignment : '<b>{event}</b> - <span class="{cls}">{allocated}</span>',
        groupBarTipInRange    : '{startDate} - {endDate}<br><span class="{cls}">{allocated} de {available}</span> atribuídos:<br>{assignments}',
        groupBarTipOnDate     : 'Em {startDate}<br><span class="{cls}">{allocated} de {available}</span> atribuídos:<br>{assignments}',
        plusMore              : '+{value} mais',
        nameColumnText        : 'Recurso/Evento'
    },

    SchedulingIssueResolutionPopup : {
        'Cancel changes'   : 'Cancelar a alteração e não fazer nada',
        schedulingConflict : 'Conflito de agendamento',
        emptyCalendar      : 'Erro de configuração de calendário',
        cycle              : 'Ciclo de agendamento',
        Apply              : 'Aplicar'
    },

    CycleResolutionPopup : {
        dependencyLabel        : 'Selecione uma dependência:',
        invalidDependencyLabel : 'Existem dependências inválidas envolvidas que têm de ser resolvidas:'
    },

    DependencyEdit : {
        Active : 'Ativo',
        From              : 'De',
        To                : 'A',
        Type              : 'Tipo',
        Lag               : 'Atraso',
        'Edit dependency' : 'Editar dependência',
        Save              : 'Guardar',
        Delete            : 'Eliminar',
        Cancel            : 'Cancelar',
        StartToStart      : 'Início a Início',
        StartToEnd        : 'Início a Fim',
        EndToStart        : 'Fim a Início',
        EndToEnd          : 'Fim a Fim'
    },

    SchedulerProBase : {
        propagating     : 'Calculando projeto',
        storePopulation : 'Carregando dados',
        finalizing      : 'Finalizando resultados'
    },


    NestedEvents : {
        deNestingNotAllowed : 'A remoção de aninhamento não é permitida',
        nestingNotAllowed   : 'O aninhamento não é permitido'
    },

    VersionGrid : {
        compare       : 'Comparar',
        description   : 'Descrição',
        occurredAt    : 'Ocorreu em',
        rename        : 'Renomear',
        restore       : 'Restaurar',
        stopComparing : 'Parar comparação'
    },


    ResourceInfoColumn : {
        eventCountText : data => data + ' evento' + (data !== 1 ? 's' : '')
    },

    Dependencies : {
        from    : 'De',
        to      : 'Até',
        valid   : 'Válido',
        invalid : 'Inválido'
    },

    DependencyType : {
        SS           : 'II',
        SF           : 'IF',
        FS           : 'FI',
        FF           : 'FF',
        StartToStart : 'Início a Início',
        StartToEnd   : 'Início a Fim',
        EndToStart   : 'Fim a Início',
        EndToEnd     : 'Fim a Fim',
        short        : [
            'II',
            'IF',
            'FI',
            'FF'
        ],
        long : [
            'Início a Início',
            'Início a Fim',
            'Fim a Início',
            'Fim a Fim'
        ]
    },


    EventEdit : {
        Name         : 'Nome',
        Resource     : 'Recurso',
        Start        : 'Início',
        End          : 'Fim',
        Save         : 'Guardar',
        Delete       : 'Eliminar',
        Cancel       : 'Cancelar',
        'Edit event' : 'Editar evento',
        Repeat       : 'Repetir'
    },

    EventDrag : {
        eventOverlapsExisting : 'O evento sobrepõe-se ao evento existente para este recurso',
        noDropOutsideTimeline : 'O evento não pode ser deixado completamente fora da cronologia'
    },

    SchedulerBase : {
        'Add event'      : 'Adicionar evento',
        'Delete event'   : 'Eliminar evento',
        'Unassign event' : 'Remover atribuição de evento',
        color            : 'Cor'
    },

    TimeAxisHeaderMenu : {
        pickZoomLevel   : 'Ampliação',
        activeDateRange : 'Intervalo de datas',
        startText       : 'Data de início',
        endText         : 'Data de fim',
        todayText       : 'Hoje'
    },

    TimeAxisColumn : {
        ariaLabel : (startDate, endDate) => `Eixo do tempo mostrando ${startDate} até ${endDate}`
    },

    EventCopyPaste : {
        copyEvent  : 'Copiar evento',
        cutEvent   : 'Cortar evento',
        pasteEvent : 'Colar evento'
    },

    EventFilter : {
        filterEvents : 'Filtrar tarefas',
        byName       : 'Por nome'
    },

    TimeRanges : {
        showCurrentTimeLine : 'Mostrar cronologia atual'
    },

    PresetManager : {
        secondAndMinute : {
            displayDateFormat : 'll LTS',
            name              : 'Segundos'
        },
        minuteAndHour : {
            topDateFormat     : 'ddd DD/MM, H',
            displayDateFormat : 'll LST'
        },
        hourAndDay : {
            topDateFormat     : 'ddd DD/MM',
            middleDateFormat  : 'LST',
            displayDateFormat : 'll LST',
            name              : 'Dia'
        },
        day : {
            name : 'Dia/horas'
        },
        week : {
            name : 'Semana/horas'
        },
        dayAndWeek : {
            displayDateFormat : 'll LST',
            name              : 'Semana/dias'
        },
        dayAndMonth : {
            name : 'Mês'
        },
        weekAndDay : {
            displayDateFormat : 'll LST',
            name              : 'Semana'
        },
        weekAndMonth : {
            name : 'Semanas'
        },
        weekAndDayLetter : {
            name : 'Semanas/dias da semana'
        },
        weekDateAndMonth : {
            name : 'Meses/semanas'
        },
        monthAndYear : {
            name : 'Meses'
        },
        year : {
            name : 'Anos'
        },
        manyYears : {
            name : 'Múltiplos anos'
        }
    },

    RecurrenceConfirmationPopup : {
        'delete-title'              : 'Está removendo um evento',
        'delete-all-message'        : 'Quer remover todas as ocorrências deste evento?',
        'delete-further-message'    : 'Quer remover esta e todas as ocorrências futuras deste evento ou apenas a ocorrência selecionada?',
        'delete-further-btn-text'   : 'Remover todos os eventos futuros',
        'delete-only-this-btn-text' : 'Remover apenas este evento',
        'update-title'              : 'Está a alterar um evento recorrente',
        'update-all-message'        : 'Quer alterar todas as ocorrências deste evento?',
        'update-further-message'    : 'Quer alterar apenas esta ocorrência do evento ou esta e todas as ocorrências futuras?',
        'update-further-btn-text'   : 'Todos os eventos futuros',
        'update-only-this-btn-text' : 'Apenas este evento',
        Yes                         : 'Sim',
        Cancel                      : 'Cancelar',
        width                       : 600
    },

    RecurrenceLegend : {
        ' and '                         : ' e ',
        Daily                           : 'Diariamente',
        'Weekly on {1}'                 : ({ days }) => `Semanalmente a ${days}`,
        'Monthly on {1}'                : ({ days }) => `Mensalmente a ${days}`,
        'Yearly on {1} of {2}'          : ({ days, months }) => `Anualmente a ${days} de ${months}`,
        'Every {0} days'                : ({ interval }) => `A cada ${interval} dias`,
        'Every {0} weeks on {1}'        : ({ interval, days }) => `A cada ${interval} semanas em ${days}`,
        'Every {0} months on {1}'       : ({ interval, days }) => `A cada ${interval} meses em ${days}`,
        'Every {0} years on {1} of {2}' : ({ interval, days, months }) => `A cada ${interval} anos em ${days} de ${months}`,
        position1                       : 'no primeiro',
        position2                       : 'no segundo',
        position3                       : 'no terceiro',
        position4                       : 'no quarto',
        position5                       : 'no quinto',
        'position-1'                    : 'no último',
        day                             : 'dia',
        weekday                         : 'dia da semana',
        'weekend day'                   : 'dia de fim de semana',
        daysFormat                      : ({ position, days }) => `${position} ${days}`
    },

    RecurrenceEditor : {
        'Repeat event'      : 'Repetir evento',
        Cancel              : 'Cancelar',
        Save                : 'Guardar',
        Frequency           : 'Frequência',
        Every               : 'A cada',
        DAILYintervalUnit   : 'dia(s)',
        WEEKLYintervalUnit  : 'semana(s)',
        MONTHLYintervalUnit : 'mês(es)',
        YEARLYintervalUnit  : 'ano(s)',
        Each                : 'Cada',
        on                  : 'Em',
        the                 : 'Em',
        'On the'            : 'Em',
        'End repeat'        : 'Repetir no fim',
        'time(s)'           : 'vez(es)',
        Days                : 'Dias',
        Months              : 'Meses'
    },

    RecurrenceDaysCombo : {
        day           : 'dia',
        weekday       : 'dia da semana',
        'weekend day' : 'dia do fim de semana'
    },

    RecurrencePositionsCombo : {
        position1    : 'primeiro',
        position2    : 'segundo',
        position3    : 'terceiro',
        position4    : 'quarto',
        position5    : 'quinto',
        'position-1' : 'último'
    },

    RecurrenceStopConditionCombo : {
        Never     : 'Nunca',
        After     : 'Depois',
        'On date' : 'Na data'
    },

    RecurrenceFrequencyCombo : {
        None    : 'Sem repetição',
        Daily   : 'Diariamente',
        Weekly  : 'Semanalmente',
        Monthly : 'Mensalmente',
        Yearly  : 'Anualmente'
    },

    RecurrenceCombo : {
        None   : 'Nenhum',
        Custom : 'Personalizar'
    },

    Summary : {
        'Summary for' : date => `Resumo de ${date}`
    },

    ScheduleRangeCombo : {
        completeview : 'Agendamento completo',
        currentview  : 'Agendamento visível',
        daterange    : 'Intervalo de datas',
        completedata : 'Agendamento completo (para todos os eventos)'
    },

    SchedulerExportDialog : {
        'Schedule range' : 'Intervalo de agendamento',
        'Export from'    : 'De',
        'Export to'      : 'Até'
    },

    ExcelExporter : {
        'No resource assigned' : 'Nenhum recurso atribuído'
    },

    CrudManagerView : {
        serverResponseLabel : 'Resposta do servidor:'
    },


    RemoveDependencyCycleEffectResolution : {
        descriptionTpl : 'Remover dependência'
    },
    DeactivateDependencyCycleEffectResolution : {
        descriptionTpl : 'Desativar dependência'
    },
    CycleEffectDescription : {
        descriptionTpl : 'Foi encontrado um ciclo, formado por: {0}'
    },
    EmptyCalendarEffectDescription : {
        descriptionTpl              : 'O calendário "{0}" não fornece quaisquer intervalos de tempo de trabalho.',
        forwardDescriptionTpl       : 'A tarefa "{2}" não pode ser executada. A agenda "{0}" não tem horário de funcionamento depois de {1}.',
        backwardDescriptionTpl      : 'A tarefa "{2}" não pode ser executada. A agenda "{0}" não tem horário de funcionamento antes de {1}.',
        noIntersectionDescriptionTpl : 'A tarefa "{2}" não pode ser executada. Sua agenda "{0}" e suas agendas de recursos não têm horário de trabalho comum.'
    },
    Use24hrsEmptyCalendarEffectResolution : {
        descriptionTpl : 'Utilize o calendário de 24 horas com sábados e domingos não úteis.'
    },
    Use8hrsEmptyCalendarEffectResolution : {
        descriptionTpl : 'Utilize o calendário de 8 horas (08:00-12:00, 13:00-17:00) com sábados e domingos não úteis.'
    },
    IgnoreProjectConstraintResolution : {
        descriptionTpl : 'Ignore a fronteira do projeto e prossiga com a mudança.'
    },
    ProjectConstraintConflictEffectDescription : {
        startDescriptionTpl : 'Você moveu a tarefa "{0}" para iniciar {1}. Isso é antes da data de início do projeto {2}.',
        endDescriptionTpl   : 'Você moveu a tarefa "{0}" para terminar {1}. Isso ocorre após a data final do projeto {2}.'
    },
    HonorProjectConstraintResolution : {
        descriptionTpl : 'Ajuste a tarefa para respeitar a borda do projeto.'
    },
    IgnoreResourceCalendarEmptyCalendarEffectResolution : {
        descriptionTpl : 'Ignore calendários de recursos e agende a tarefa usando apenas seu próprio calendário.'
    },
    ConflictEffectDescription : {
        descriptionTpl : 'Foi encontrado um conflito de agendamento: {0} está em conflito com {1}'
    },
    ConstraintIntervalDescription : {
        dateFormat : 'LLL'
    },
    ProjectConstraintIntervalDescription : {
        startDateDescriptionTpl : 'Data de início do projeto {0}',
        endDateDescriptionTpl   : 'Data do fim do projeto {0}'
    },
    ManuallyScheduledParentConstraintIntervalDescription : {
        startDescriptionTpl : 'Agendamento manual "{2}" obriga os seus filhos a não começar antes de {0}',
        endDescriptionTpl   : 'Agendamento manual "{2}" obriga os seus filhos a terminar o mais tardar a {1}'
    },
    DisableManuallyScheduledConflictResolution : {
        descriptionTpl : 'Desativar agendamento manual para "{0}"'
    },
    DependencyConstraintIntervalDescription : {
        descriptionTpl : 'Dependência ({2}) de "{3}" para "{4}"'
    },
    RemoveDependencyResolution : {
        descriptionTpl : 'Remover dependência de "{1}" para "{2}"'
    },
    DeactivateDependencyResolution : {
        descriptionTpl : 'Desativar dependência de "{1}" para "{2}"'
    },
    DateConstraintIntervalDescription : {
        startDateDescriptionTpl : 'Restrições {3} {0} da tarefa "{2}"',
        endDateDescriptionTpl   : 'Restrições {3} {1} da tarefa "{2}"',
        constraintTypeTpl : {
            startnoearlierthan  : 'Iniciar não antes de',
            finishnoearlierthan : 'Terminar não antes de',
            muststarton         : 'Tem de começar em',
            mustfinishon        : 'Tem de terminar em',
            startnolaterthan    : 'Iniciar não depois de',
            finishnolaterthan   : 'Terminar não depois de'
        }
    },
    RemoveDateConstraintConflictResolution : {
        descriptionTpl : 'Remover a restrição "{1}" da tarefa "{0}"'
    },

    ColumnPicker : {
        column          : 'Coluna',
        columnsMenu     : 'Colunas',
        hideColumn      : 'Ocultar colunas',
        hideColumnShort : 'Ocultar',
        newColumns      : 'Novas colunas'
    },

    Filter : {
        applyFilter   : 'Aplicar filtro',
        filter        : 'Filtro',
        editFilter    : 'Editar filtro',
        on            : 'em',
        before        : 'Antes',
        after         : 'Depois',
        equals        : 'Igual a',
        lessThan      : 'Inferior a',
        moreThan      : 'Superior a',
        removeFilter  : 'Remover filtro',
        disableFilter : 'Desativar filtro'
    },

    FilterBar : {
        enableFilterBar  : 'Mostrar barra de filtro',
        disableFilterBar : 'Ocultar barra de filtro'
    },

    Group : {
        group                : 'Agrupar',
        groupAscending       : 'Agrupar por ordem ascendente',
        groupDescending      : 'Agrupar por ordem descendente',
        groupAscendingShort  : 'Ascendente',
        groupDescendingShort : 'Descendente',
        stopGrouping         : 'Parar agrupamento',
        stopGroupingShort    : 'Parar'
    },

    HeaderMenu : {
        moveBefore     : text => `Mover para antes de "${text}"`,
        moveAfter      : text => `Mover para depois de "${text}"`,
        collapseColumn : 'Minimizar coluna',
        expandColumn   : 'Ampliar coluna'
    },

    ColumnRename : {
        rename : 'Renomear'
    },

    MergeCells : {
        mergeCells  : 'Unir céculas',
        menuTooltip : 'Unir células com o mesmo valor quando ordenadas por esta coluna'
    },

    Search : {
        searchForValue : 'Pesquisar por valor'
    },

    Sort : {
        sort                   : 'Ordenar',
        sortAscending          : 'Ordenar por ordem ascendente',
        sortDescending         : 'Ordenar por ordem descendente',
        multiSort              : 'Ordenação múltipla',
        removeSorter           : 'Remover ordenação',
        addSortAscending       : 'Adicionar ordenação ascendente',
        addSortDescending      : 'Adicionar ordenação descendente',
        toggleSortAscending    : 'Alterar para ascendente',
        toggleSortDescending   : 'Alterar para descendente',
        sortAscendingShort     : 'Ascendente',
        sortDescendingShort    : 'Descendente',
        removeSorterShort      : 'Remover',
        addSortAscendingShort  : '+ Ascendente',
        addSortDescendingShort : '+ Descendente'
    },

    Split : {
        split        : 'Dividido',
        unsplit      : 'Não dividido',
        horizontally : 'Horizontalmente',
        vertically   : 'Verticalmente',
        both         : 'Ambos'
    },

    LockRows : {
        lockRow   : 'Bloquear linha',
        unlockRow : 'Desbloquear linha'
    },

    Column : {
        columnLabel : column => `${column.text ? `${column.text} coluna. ` : ''}ESPAÇO para menu de contexto${column.sortable ? ', ENTER para ordenar' : ''}`,
        cellLabel   : new String()
    },

    Checkbox : {
        toggleRowSelect : 'Ativar/desativar seleção de fila',
        toggleSelection : 'Ativar/desativar seleção de todo o conjunto de dados'
    },

    RatingColumn : {
        cellLabel : column => `${column.text ? column.text : ''} ${column.location?.record ? `avaliação ${column.location.record.get(column.field) || 0}` : ''}`
    },

    GridBase : {
        loadFailedMessage  : 'O carregamento de dados falhou!',
        syncFailedMessage  : 'A sincronização de dados falhou!',
        unspecifiedFailure : 'Falha não especificada',
        networkFailure     : 'Erro de rede',
        parseFailure       : 'Falha ao analisar a resposta do servidor',
        serverResponse     : 'Resposta do servidor:',
        noRows             : 'Sem registos para exibir',
        moveColumnLeft     : 'Mover para a seção esquerda',
        moveColumnRight    : 'Mover para a seção direita',
        moveColumnTo       : region => `Mover coluna para ${region}`,
        loadMask : 'Carregando...',
        syncMask : 'Salvando alterações, aguarde...'
    },

    CellMenu : {
        removeRow : 'Remover'
    },

    RowCopyPaste : {
        copyRecord  : 'Copiar',
        cutRecord   : 'Cortar',
        pasteRecord : 'Colar',
        rows        : 'linhas',
        row         : 'linha'
    },

    CellCopyPaste : {
        copy  : 'Copiar',
        cut   : 'Cortar',
        paste : 'Colar'
    },

    PdfExport : {
        'Waiting for response from server' : 'Aguardando resposta do servidor...',
        'Export failed'                    : 'Falha ao exportar',
        'Server error'                     : 'Erro de servidor',
        'Generating pages'                 : 'Gerando páginas...',
        'Click to abort'                   : 'Cancelar'
    },

    ExportDialog : {
        width          : '40em',
        labelWidth     : '12em',
        exportSettings : 'Exportar definições',
        export         : 'Exportar',
        printSettings  : 'Configurações de impressão',
        print          : 'Imprimir',
        exporterType   : 'Controle de paginação',
        cancel         : 'Cancelar',
        fileFormat     : 'Formato do arquivo',
        rows           : 'Filas',
        alignRows      : 'Alinhar filas',
        columns        : 'Colunas',
        paperFormat    : 'Formato em papel',
        orientation    : 'Orientação',
        repeatHeader   : 'Repetir cabeçalho'
    },

    ExportRowsCombo : {
        all     : 'Todas as filas',
        visible : 'Filas visíveis'
    },

    ExportOrientationCombo : {
        portrait  : 'Retrato',
        landscape : 'Paisagem'
    },

    SinglePageExporter : {
        singlepage : 'Uma página'
    },

    MultiPageExporter : {
        multipage     : 'Várias páginas',
        exportingPage : ({ currentPage, totalPages }) => `Exportando página ${currentPage}/${totalPages}`
    },

    MultiPageVerticalExporter : {
        multipagevertical : ' Várias páginas (vertical)',
        exportingPage     : ({ currentPage, totalPages }) => `Exportando página ${currentPage}/${totalPages}`
    },

    RowExpander : {
        loading  : 'Carregando',
        expand   : 'Expandir',
        collapse : 'Fechar'
    },

    TreeGroup : {
        group                  : 'Agrupar por',
        stopGrouping           : 'Parar agrupamento',
        stopGroupingThisColumn : 'Remover agrupamento desta coluna'
    },


    ColorPicker : {
        noColor : 'Sem cor'
    },

    Combo : {
        noResults          : 'Sem resultados',
        recordNotCommitted : 'Não foi possível adicionar o registo',
        addNewValue        : value => `Adicionar ${value}`
    },

    FilePicker : {
        file : 'Arquivo'
    },

    Field : {
        badInput              : 'Valor de campo inválido',
        patternMismatch       : 'O valor deve corresponder a um padrão específico',
        rangeOverflow         : value => `O valor deve ser inferior ou igual a ${value.max}`,
        rangeUnderflow        : value => `O valor deve ser superior ou igual a ${value.min}`,
        stepMismatch          : 'O valor deve corresponder ao passo',
        tooLong               : 'O valor deve ser mais curto',
        tooShort              : 'O valor deve ser mais comprido',
        typeMismatch          : 'O valor deve estar num formato especial',
        valueMissing          : 'Este campo é obrigatório',
        invalidValue          : 'Valor de campo inválido',
        minimumValueViolation : 'Erro de valor mínimo',
        maximumValueViolation : 'Erro de valor máximo',
        fieldRequired         : 'Este campo é obrigatório',
        validateFilter        : 'O valor deve ser selecionado a partir da lista'
    },

    DateField : {
        invalidDate : format => 'Data inválida, o formato esperado é ' + format
    },

    DatePicker : {
        gotoPrevYear  : 'Ir para o ano anterior',
        gotoPrevMonth : 'Ir para o mês anterior',
        gotoNextMonth : 'Ir para o mês seguinte',
        gotoNextYear  : 'Ir para o ano seguinte'
    },

    NumberFormat : {
        locale   : 'pt-BR',
        currency : 'BRL'
    },

    DurationField : {
        invalidUnit : 'Unidade inválida'
    },

    TimeField : {
        invalidTime : 'Hora inválida'
    },

    TimePicker : {
        hour   : 'Hora',
        minute : 'Minuto',
        second : 'Segundo'
    },

    List : {
        loading   : 'Carregando...',
        selectAll : 'Selecionar Todos'
    },


    PagingToolbar : {
        firstPage         : 'Ir para a primeira página',
        prevPage          : 'Ir para a página anterior',
        page              : 'Página',
        nextPage          : 'Ir para a página seguinte',
        lastPage          : 'Ir para a última página',
        reload            : 'Recarregar página atual',
        noRecords         : 'Sem registos',
        pageCountTemplate : data => `de ${data.lastPage}`,
        summaryTemplate   : data => `Mostrando registos ${data.start} - ${data.end} até ${data.allCount}`
    },

    PanelCollapser : {
        Collapse : 'Fechar',
        Expand   : 'Expandir'
    },

    Popup : {
        close : 'Fechar mensagem pop-up'
    },

    UndoRedo : {
        Undo           : 'Desfazer',
        Redo           : 'Refazer',
        UndoLastAction : 'Desfazer a última ação',
        RedoLastAction : 'Refazer a última ação',
        NoActions      : 'Não existem itens na fila de ações'
    },

    FieldFilterPicker : {
        equals                 : 'igual a',
        doesNotEqual           : 'não é igual a',
        isEmpty                : 'está vazio',
        isNotEmpty             : 'não está vazio',
        contains               : 'contém',
        doesNotContain         : 'não contém',
        startsWith             : 'começa por',
        endsWith               : 'termina por',
        isOneOf                : 'é um de',
        isNotOneOf             : 'não é um de',
        isGreaterThan          : 'é maior do que',
        isLessThan             : 'é menor do que',
        isGreaterThanOrEqualTo : 'é maior do que ou igual a',
        isLessThanOrEqualTo    : 'é menor do que ou igual a',
        isBetween              : 'está entre',
        isNotBetween           : 'não está entre',
        isBefore               : 'está antes de',
        isAfter                : 'está depois de',
        isToday                : 'é hoje',
        isTomorrow             : 'é amanhã',
        isYesterday            : 'é ontem',
        isThisWeek             : 'é esta semana',
        isNextWeek             : 'é a próxima semana',
        isLastWeek             : 'é a semana passada',
        isThisMonth            : 'é este mês',
        isNextMonth            : 'é o próximo mês',
        isLastMonth            : 'é o último mês',
        isThisYear             : 'é este ano',
        isNextYear             : 'é o próximo ano',
        isLastYear             : 'é o último ano',
        isYearToDate           : 'é o ano até à data',
        isTrue                 : 'é verdadeiro',
        isFalse                : 'é falso',
        selectAProperty        : 'Selecione uma propriedade',
        selectAnOperator       : 'Selecione um operador',
        caseSensitive          : 'Case-sensitive',
        and                    : 'e',
        dateFormat             : 'D/M/YY',
        selectValue            : 'Selecione valor',
        selectOneOrMoreValues  : 'Selecione um ou mais valores',
        enterAValue            : 'Digite um valor',
        enterANumber           : 'Digite um número',
        selectADate            : 'Selecione uma data',
        selectATime            : 'Selecione hora'
    },

    FieldFilterPickerGroup : {
        addFilter : 'Adicionar filtro'
    },

    DateHelper : {
        locale         : 'pt-BR',
        weekStartDay   : 1,
        nonWorkingDays : {
            0 : true,
            6 : true
        },
        weekends : {
            0 : true,
            6 : true
        },
        unitNames : [
            { single : 'milissegundo', plural : 'ms', abbrev : 'ms' },
            { single : 'emilissegundo', plural : 'ems', abbrev : 'ems' },
            { single : 'segundo', plural : 'segundos', abbrev : 's' },
            { single : 'esegundo', plural : 'esegundos', abbrev : 'es' },
            { single : 'minuto', plural : 'minutos', abbrev : 'min' },
            { single : 'eminuto', plural : 'eminutos', abbrev : 'emin' },
            { single : 'hora', plural : 'horas', abbrev : 'h' },
            { single : 'ehora', plural : 'ehoras', abbrev : 'eh' },
            { single : 'dia', plural : 'dias', abbrev : 'd' },
            { single : 'edia', plural : 'edias', abbrev : 'ed' },
            { single : 'semana', plural : 'semanas', abbrev : 'sem' },
            { single : 'esemana', plural : 'esemanas', abbrev : 'esem' },
            { single : 'mês', plural : 'meses', abbrev : 'mês' },
            { single : 'emês', plural : 'emeses', abbrev : 'emês' },
            { single : 'trimestre', plural : 'trimestres', abbrev : 'trim' },
            { single : 'etrimestre', plural : 'etrimestres', abbrev : 'etrim' },
            { single : 'ano', plural : 'anos', abbrev : 'a' },
            { single : 'eano', plural : 'eanos', abbrev : 'ea' },
            { single : 'década', plural : 'décadas', abbrev : 'dec' },
            { single : 'edécada', plural : 'edécadas', abbrev : 'edec' }
        ],
        unitAbbreviations : [
            ['mil'],
            ['emil'],
            ['s', 'seg'],
            ['es', 'eseg'],
            ['m', 'min'],
            ['em', 'emin'],
            ['h', 'hr'],
            ['eh', 'ehr'],
            ['d'],
            ['ed'],
            ['sem', 'seman'],
            ['esem', 'eseman'],
            ['m', 'mês', 'mes'],
            ['em', 'emês', 'emes'],
            ['t', 'trim', 'trmt'],
            ['et', 'etrim', 'etrmt'],
            ['a', 'ano'],
            ['ea', 'eano'],
            ['dec'],
            ['edec']
        ],
        parsers : {
            L   : 'DD/MM/YYYY',
            LT  : 'HH:mm',
            LTS : 'HH:mm:ss A'
        },
        ordinalSuffix : number => {
            return number + '°';
        }
    }
}

export default locale
